export type PhoneNumber = {
	phone: string;
	code?: string;
};

export const MAX_ATTEMPTS_TO_CONFIRM_PHONE = 3;
